import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getApiUrl } from "../env";

interface BlogPost {
    id: number;
    title: string;
    slug: string;
    excerpt: string;
    coverImageUrl: string | null;
    category: string | null;
    publishedAt: string;
}

interface BlogSec1Props {
    limit?: number;
}

const API_BASE = getApiUrl();

const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString('pl-PL', { day: '2-digit', month: 'short', year: 'numeric' }).toUpperCase();

const BlogSec1: React.FC<BlogSec1Props> = ({ limit }) => {
    const [posts, setPosts] = useState<BlogPost[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${API_BASE}/api/blog`)
            .then(r => r.json())
            .then((data: BlogPost[]) => {
                setPosts(limit ? data.slice(0, limit) : data);
            })
            .catch(() => setPosts([]))
            .finally(() => setLoading(false));
    }, [limit]);

    if (loading) return null;
    if (posts.length === 0) return (
        <div className="row home-blog-row blogPage-row2">
            <p style={{ textAlign: 'center', color: '#888', padding: '2rem' }}>Brak wpisów.</p>
        </div>
    );

    return (
        <div className="row home-blog-row blogPage-row2">
            {posts.map((post) => (
                <div
                    className="col-xxl-4 col-xl-4 col-lg-4 col-md-6"
                    key={post.id}
                >
                    <Link to={`/blog/${post.slug}`} className="blog-box-main zoom_in">
                        <div className="blog-img-main">
                            {post.coverImageUrl ? (
                                <img
                                    src={post.coverImageUrl.startsWith('http') ? post.coverImageUrl : `${API_BASE}${post.coverImageUrl}`}
                                    alt={post.title}
                                />
                            ) : (
                                <div style={{ height: 220, background: '#f3f4f6' }} />
                            )}
                            <h3 className="blog-date">{formatDate(post.publishedAt)}</h3>
                        </div>
                        <div className="blog-containe-main">
                            <h2>{post.title}</h2>
                            <p>{post.excerpt}</p>
                        </div>
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default BlogSec1;
